// extracted by mini-css-extract-plugin
export default {"page":"yW-z","cartModal":"zW-z","checkout":"AW-z","placeholder":"BW-z","account":"CW-z"};